<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="title">

    <form #mapForm="ngForm" autocomplete="off" class="main-container">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="scopeObj.name" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <div class="form-row">
            <mat-form-field class="fullWidth">
                <mat-label>Weight</mat-label>
                <input matInput [(ngModel)]="scopeObj.weight" type="number" min="1"
                       max="100" name="weight" required>
            </mat-form-field>

            <mat-form-field class="fullWidth">
                <mat-label>Transport Type</mat-label>
                <mat-select [(ngModel)]="scopeObj.transportType" name="voipPeerId">
                    <mat-option *ngFor="let item of transportProtocolOptions" [value]="item.value">
                        {{item.text}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-row">
            <div class="form-column">
                <span class="node-configuration-title">Node 1</span>
                <mat-form-field class="fullWidth">
                    <mat-label>Node</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedSrcNode" [disabled]="editMode" required
                                (selectionChange)=" updateSrcRIOptions(); updateDestNodeOptions(); updateSrcNodeData($event.value);
                            updateEdgesName(); updateSrcIpProfiles(); updateSrcMediaRealm()" name="selectedSrcNode">
                        <mat-option *ngFor="let item of options.srcNodes" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Source node is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Routing Interface</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedSrcRI" [disabled]="editMode" (selectionChange)="updateEdgesName()"
                                name="selectedSrcRI" required>
                        <mat-option *ngFor="let item of options.srcRIs" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Source Routing Interface is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="scopeObj.srcNodeEdgeName" [disabled]="isSrcNodeIsThirdParty"
                           name="srcNodeEdgeName" required maxlength="40">
                    <mat-error>
                        Source Edge Name is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>IP Profile</mat-label>
                    <mat-select [(ngModel)]="scopeObj.srcIpProfile" [disabled]="isSrcNodeIsThirdParty"
                                name="srcIpProfile" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of options.srcIpProfiles" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Source IP Profiles is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Media Realm</mat-label>
                    <mat-select [(ngModel)]="scopeObj.srcMediaRealm"
                                [disabled]="isSrcNodeIsThirdParty || !isSrcNodeSupportsTeams" name="srcMediaRealm">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of options.srcMediaRealm" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>SIP Group name</mat-label>
                    <input matInput [disabled]="isSrcNodeIsThirdParty || !isSrcNodeSupportsTeams"
                           [required]="isSrcGroupNameRequired()"
                           [(ngModel)]="scopeObj.srcSipGroupName" name="srcSipGroupName">
                </mat-form-field>
            </div>

            <div class="form-column">
                <span class="node-configuration-title">Node 2</span>
                <mat-form-field class="fullWidth">
                    <mat-label>Node</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedDestNode" [disabled]="editMode"
                                (selectionChange)="updateDestRIOptions(); updateSrcNodeOptions(); updateDestNodeData($event.value);
                            updateEdgesName(); updateDestIpProfiles(); updateDestMediaRealm()" name="selectedDestNode" required>
                        <mat-option *ngFor="let item of options.destNodes" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Destination node is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Routing Interface</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedDestRI" [disabled]="editMode" (selectionChange)="updateEdgesName()"
                                name="selectedDestRI" required>
                        <mat-option *ngFor="let item of options.destRIs" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Destination Routing Interface is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="scopeObj.destNodeEdgeName" [disabled]="isDestNodeIsThirdParty"
                           name="destNodeEdgeName" required maxlength="40">
                    <mat-error>
                         Edge Name is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>IP Profile</mat-label>
                    <mat-select [(ngModel)]="scopeObj.destIpProfile" [disabled]="isDestNodeIsThirdParty"
                                name="destIpProfile" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of options.destIpProfiles" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Destination IP Profiles is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Media Realm</mat-label>
                    <mat-select [(ngModel)]="scopeObj.destMediaRealm"
                                [disabled]="isDestNodeIsThirdParty || !isDestNodeSupportsTeams" name="destMediaRealm">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of options.destMediaRealm" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>SIP Group name</mat-label>
                    <input matInput [disabled]="isDestNodeIsThirdParty || !isDestNodeSupportsTeams"
                           [required]="isDestGroupNameRequired()"
                           [(ngModel)]="scopeObj.destSipGroupName" name="destSipGroupName">
                    <mat-error>
                        Destination Edge Name is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <divider title="Advanced Conditions"></divider>

        <mat-checkbox [(ngModel)]="scopeObj.shouldSync"
                      [ngModelOptions]="{standalone: true}"
                      color="primary">
            Keep connection properties synchronized
        </mat-checkbox>

        <div class="advanced-conditions" *ngIf="advancedConditions.isQualityEnabled">
            <mat-radio-group [(ngModel)]="scopeObj.useGlobalAdvancedCondition" [ngModelOptions]="{standalone: true}">
                <div class="form-row">
                    <div class="form-column">
                        <mat-radio-button color="primary" value="global">use global quality definitions
                        </mat-radio-button>
                    </div>
                    <div class="form-column">
                        <mat-radio-button color="primary" value="specific">use specific quality definitions
                        </mat-radio-button>
                        <div class="quality">
                            <mat-checkbox [disabled]="scopeObj.useGlobalAdvancedCondition === 'global'" name="mos"
                                          color="primary"
                                          [(ngModel)]="connection.quality.MOS.isUsed">MOS
                            </mat-checkbox>
                            <mat-checkbox [disabled]="scopeObj.useGlobalAdvancedCondition === 'global'" name="asr"
                                          color="primary"
                                          [(ngModel)]="connection.quality.ASR.isUsed">ASR
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </form>
</arm-dialog>
